/** Opens only the native microphone page; browsers and older shells return false. */
export async function openDesktopMicrophoneSettings(): Promise<boolean> {
  if (typeof window === 'undefined' || !('imaiDesktop' in window)) return false;
  const bridge = window.imaiDesktop;
  if (
    !bridge ||
    typeof bridge !== 'object' ||
    !('version' in bridge) ||
    bridge.version !== 1 ||
    !('openMicrophoneSettings' in bridge) ||
    typeof bridge.openMicrophoneSettings !== 'function'
  )
    return false;
  return (await bridge.openMicrophoneSettings()) === true;
}
